import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  BackButton,
  Balance,
  BalanceContainer,
  BalanceDollar,
  Card,
  CardHeader,
  CardHeaderColumn,
  CardHeaderSubtitle,
  CardHeaderTitle,
  Cards,
  CardText,
  CardTextRow,
  Container,
  FooterText,
  Pagination,
  PaginationButton,
  PaginationCurrent,
  Row,
  SectionHeader,
  SectionTitle,
  SmallTitle,
  SmallTitleRow,
  Table,
  TableCell,
  TableContainer,
  TableFooter,
  TableHeader,
  TableLoading,
  TableRow,
  TextContainer,
  Title,
  FooterActions,
  BalanceSection,
  MobileTextContainer,
  //   Tooltip,
  //   Relative,
} from "./WalletPage.styles";

import Button from "../../components/utils/Button/Button";
import MainContainer from "../../components/MainContainer";

import { ReactComponent as StarSvg } from "../../assets/icons/gradientStar.svg";
import { ReactComponent as WhiteStarSvg } from "../../assets/icons/whiteStar.svg";
import { ReactComponent as UsersSvg } from "../../assets/icons/users.svg";
// import { ReactComponent as InfoSvg } from "../../assets/icons/info-circle.svg";
import { ReactComponent as CoinsSvg } from "../../assets/icons/coins.svg";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";

import { formatDate, priceFormatterDecimal } from "../../utils/utils";
import RequestWithdrawalModal from "../../components/RequestWithdrawalModal/RequestWithdrawalModal";
import { useDispatch, useSelector } from "react-redux";
import { selectRequestWithdrawal } from "../../store/slices/payment/slice";
import { fetchRequestWithdrawal } from "../../store/slices/payment/asyncThunk";
import { selectUser } from "../../store/slices/user/slice";

const HeaderComponent = ({ balance, openModal }) => {
  const calculatePrice = (starts) => {
    const pricePerStart = 10 / 300;
    return (starts * pricePerStart).toFixed(2);
  };

  return (
    <>
      <TextContainer>
        <Title>Wallet</Title>
        <SmallTitleRow>
          <SmallTitle>Available Balance</SmallTitle>
          <Button
            title={"Request Withdrawal"}
            textColor="white"
            onClick={openModal}
            background="linear-gradient(180deg, var(--100, #4D9DFF) 0%, var(--200, #2877D9) 100%)"
          />
        </SmallTitleRow>
        <BalanceContainer>
          <StarSvg />
          <Balance>{priceFormatterDecimal(balance)}</Balance>
          <BalanceDollar>~ ${calculatePrice(balance)}</BalanceDollar>
        </BalanceContainer>
      </TextContainer>

      <MobileTextContainer>
        <Title>Wallet</Title>
        <SmallTitleRow>
          <SmallTitle>Available Balance</SmallTitle>
          <BalanceContainer>
            <Row>
              <StarSvg />
              <Balance>{priceFormatterDecimal(balance)}</Balance>
            </Row>
            <BalanceDollar>~ ${calculatePrice(balance)}</BalanceDollar>
          </BalanceContainer>
        </SmallTitleRow>
        <Button
          title={"Request Withdrawal"}
          textColor="white"
          onClick={openModal}
          background="linear-gradient(180deg, var(--100, #4D9DFF) 0%, var(--200, #2877D9) 100%)"
        />
      </MobileTextContainer>
    </>
  );
};

const WalletPage = () => {
  const navigate = useNavigate();
  //   const [hoveredPendingReferral, setHoveredPendingReferral] = useState(null);
  //   const [hoveredPendingTemplate, setHoveredPendingTemplate] = useState(null);
  const [isBalanceExpanded, setIsBalanceExpanded] = useState(true);
  const [withdrawalOpen, setWithdrawalOpen] = useState(false);
  const requestWithdrawalData = useSelector(selectRequestWithdrawal);

  const user = useSelector(selectUser);

  const creditsHistoryPage = requestWithdrawalData.page;
  const creditsHistoryTotal = requestWithdrawalData.total;
  const creditsHistoryPerPage = 10;

  const handlePageChange = (nextPage) => {
    dispatch(fetchRequestWithdrawal({ nextPage }));
  };

  const handleBack = () => {
    navigate(-1);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  const toggleBalance = () => {
    setIsBalanceExpanded(!isBalanceExpanded);
  };

  const openModal = () => {
    setWithdrawalOpen(true);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRequestWithdrawal());
  }, [dispatch]);

  return (
    <MainContainer>
      <Container>
        <BackButton onClick={handleBack}>
          <ChevronSvg />
          Back
        </BackButton>

        <HeaderComponent balance={user.credits} openModal={openModal} />

        <Cards>
          <Card>
            <CardHeader>
              <CardHeaderColumn>
                <CardHeaderTitle>Referral Balance</CardHeaderTitle>
                <CardHeaderSubtitle>
                  Earned from users you invited
                </CardHeaderSubtitle>
              </CardHeaderColumn>
              <UsersSvg height={24} width={24} />
            </CardHeader>
            <CardTextRow>
              <CardText>Available</CardText>
              <Row>
                <WhiteStarSvg />
                <CardText>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <Row>
                <CardText $light>Pending</CardText>
                {/* <Relative
                  onMouseEnter={() => {
                    setHoveredPendingReferral(true);
                  }}
                  onMouseLeave={() => {
                    setHoveredPendingReferral(false);
                  }}
                >
                  <Tooltip $show={hoveredPendingReferral}>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </Tooltip>
                  <InfoSvg width={18} height={18} />
                </Relative> */}
              </Row>
              <Row>
                <WhiteStarSvg />
                <CardText $light>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <CardText $light>Lifetime</CardText>
              <Row>
                <WhiteStarSvg />
                <CardText $light>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
          </Card>

          <Card>
            <CardHeader>
              <CardHeaderColumn>
                <CardHeaderTitle>Template Balance </CardHeaderTitle>
                <CardHeaderSubtitle>
                  Earned from template sales
                </CardHeaderSubtitle>
              </CardHeaderColumn>
              <CoinsSvg height={24} width={24} />
            </CardHeader>
            <CardTextRow>
              <CardText>Available</CardText>
              <Row>
                <WhiteStarSvg />
                <CardText>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <Row>
                <CardText $light>Pending</CardText>
                {/* <Relative
                  onMouseEnter={() => {
                    setHoveredPendingTemplate(true);
                  }}
                  onMouseLeave={() => {
                    setHoveredPendingTemplate(false);
                  }}
                >
                  <Tooltip $show={hoveredPendingTemplate}>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </Tooltip>
                  <InfoSvg width={18} height={18} />
                </Relative> */}
              </Row>
              <Row>
                <WhiteStarSvg />
                <CardText $light>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <CardText $light>Lifetime</CardText>
              <Row>
                <WhiteStarSvg />
                <CardText $light>{priceFormatterDecimal(0)}</CardText>
              </Row>
            </CardTextRow>
          </Card>
        </Cards>

        <BalanceSection>
          <SectionHeader onClick={toggleBalance}>
            <SectionTitle>History</SectionTitle>
            <ChevronSvg
              size={14}
              style={{
                transition: "transform 0.3s ease-in-out",
                transform: isBalanceExpanded
                  ? "rotate(90deg)"
                  : "rotate(-90deg)",
                cursor: "pointer",
                opacity: 0.7,
              }}
            />
          </SectionHeader>
          <TableContainer $isExpanded={isBalanceExpanded}>
            <Table>
              <thead>
                <TableRow>
                  <TableHeader>Description</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Amount</TableHeader>
                  <TableHeader>Status</TableHeader>
                </TableRow>
              </thead>
              <tbody>
                {requestWithdrawalData.loading ? (
                  <TableCell
                    colSpan={4}
                    style={{ textAlign: "center", height: 100 }}
                  >
                    <TableLoading>
                      <l-line-spinner
                        size="24"
                        stroke="2"
                        speed="1.5"
                        color="#fff"
                      />
                      <span>Loading transaction history...</span>
                    </TableLoading>
                  </TableCell>
                ) : requestWithdrawalData.data.length === 0 ||
                  !requestWithdrawalData.data ? (
                  <TableCell
                    colSpan={4}
                    style={{
                      textAlign: "center",
                      height: 100,
                      textTransform: "unset",
                    }}
                  >
                    <TableLoading>
                      <span>You have no transactions yet.</span>
                    </TableLoading>
                  </TableCell>
                ) : (
                  requestWithdrawalData.data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell $isFirst={true} style={{ color: "#fff" }}>
                        Request Withdrawal
                      </TableCell>
                      <TableCell style={{ color: "#fff" }}>
                        {formatDate(item?.createdAt)}
                      </TableCell>

                      <TableCell style={{ color: "#fff" }}>
                        <Row>
                          <StarSvg />
                          {priceFormatterDecimal(item?.amount)}
                        </Row>
                      </TableCell>

                      <TableCell style={{ color: "#fff" }}>
                        {item?.status}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </tbody>
            </Table>

            <TableFooter>
              <FooterActions>
                <FooterText>
                  Showing {requestWithdrawalData.data.length} of{" "}
                  {creditsHistoryTotal} grants
                </FooterText>
              </FooterActions>
              <FooterActions>
                <Pagination>
                  <PaginationButton
                    disabled={creditsHistoryPage <= 1}
                    onClick={() => handlePageChange(creditsHistoryPage - 1)}
                  >
                    Previous
                  </PaginationButton>

                  <PaginationCurrent>
                    Page {creditsHistoryPage} of{" "}
                    {Math.ceil(creditsHistoryTotal / creditsHistoryPerPage)}
                  </PaginationCurrent>

                  <PaginationButton
                    disabled={
                      creditsHistoryPage >=
                      Math.ceil(creditsHistoryTotal / creditsHistoryPerPage)
                    }
                    onClick={() => handlePageChange(creditsHistoryPage + 1)}
                  >
                    Next
                  </PaginationButton>
                </Pagination>
              </FooterActions>
            </TableFooter>
          </TableContainer>
        </BalanceSection>
      </Container>
      <RequestWithdrawalModal
        isOpen={withdrawalOpen}
        onClose={() => {
          setWithdrawalOpen(false);
        }}
      />
    </MainContainer>
  );
};

export default WalletPage;
